<template>
    <vs-popup :active.sync="active" title="Are you sure?">
        <vs-row>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5>Action</h5>
            </vs-col>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5 class="text-right">
                    <template v-if="action == 'approve'">Approve</template>
                    <template v-else-if="action == 'reject'">Reject</template>
                    <template v-else>Unknown</template>
                </h5>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5>Date/Time</h5>
            </vs-col>
            <vs-col vs-xs="6" vs-sm="6" vs-lg="6">
                <h5 class="text-right">
                    <FormatText :text="new Date().toISOString()" format="datetime" />
                </h5>
            </vs-col>
        </vs-row>
        <vs-row class="mt-5">
            <vs-col>
                <h5 class="block">Comment</h5>
                <vs-textarea v-model="data.comment" placeholder="Type Here..." />
            </vs-col>
        </vs-row>
        <vs-row class="mt-5">
            <vs-col>
                <vs-button @click="$emit('cancel')" :disabled="disabled" color="danger" class="mx-2">Cancel</vs-button>
                <vs-button @click="$emit('submit')" :disabled="disabled" color="primary">Submit</vs-button>
            </vs-col>
        </vs-row>
    </vs-popup>
</template>

<script>
export default {
    props: {
        is_active: {
            type: Boolean,
            required: true,
            default: false
        },
        disabled: {
            type: Boolean,
            required: true,
            default: false
        },
        action: {
            type: String | null,
            required: true
        },
        comment:{ 
            type: String | null,
            required: true
        }
    },
    data() {
        return {
            active: this.is_active,
            data: {
                comment: this.comment
            }
        }
    },
    watch: {
        active (newV, oldV) {
            if (newV !== oldV) this.$emit('update:is_active', newV)
        },
        is_active (newV, oldV) {
            if (newV !== oldV) this.active = newV
        },
        'data.comment' (newV) {
            this.$emit('update:comment', newV)
        }
    }
}
</script>